<template>
    <div class="help-container">
      <h2 class="help-title">Ayuda para la Gestión de Médicos</h2>
      <p class="help-introduction">Este módulo permite administrar la información de los médicos dentro del sistema. A continuación, se detallan las principales funcionalidades disponibles:</p>
      <ul class="help-list">
        <li><strong>Visualización de Detalles:</strong> Muestra información detallada del médico seleccionado, incluyendo su especialidad y datos de contacto.</li>
        <li><strong>Edición de Médicos:</strong> Permite modificar la información del médico. Solo es posible cuando se selecciona el botón de editar correspondiente.</li>
        <li><strong>Agregar Nuevos Médicos:</strong> Facilita la entrada de nuevos médicos al sistema a través de un formulario accesible mediante el botón "Nuevo registro".</li>
        <li><strong>Buscar y Filtrar:</strong> Ofrece herramientas para buscar médicos específicos o filtrar por fechas y otros criterios relevantes.</li>
        <li><strong>Generación de Agenda:</strong> Permite generar agendas mensuales o anuales para los médicos, facilitando la planificación de sus actividades.</li>
        <li><strong>Acciones de Estado:</strong> Cada médico puede ser activado o desactivado desde la interfaz, lo cual es reflejado en el sistema en tiempo real.</li>
      </ul>
      <p class="help-conclusion">Utiliza las herramientas proporcionadas para una gestión eficiente del personal médico y asegúrate de guardar los cambios realizados durante la edición de los datos.</p>
    </div>
  </template>
  
  <script>
  export default {
    name: "AyudaMedico"
  };
  </script>
  <style src="@/assets/css/ayuda.css" scoped></style>